"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parentOrigin = exports.isR4 = exports.R4_MESSAGE_TYPE = exports.OFFLINE_OTP = exports.SYSTEM_MESSAGE_HARD_TOKEN = exports.VerifyDataStatusFirstCall = exports.SYSTEM_MESSAGES_LOGIN2FA = exports.SYSTEM_MESSAGES_TRANSACTION_SIGNING = exports.RouteTypes = exports.PLESE_ENTER_THE_CORRECT_OTP = void 0;
const PLESE_ENTER_YOUR_OTP = 'Please enter your One-time password.';
exports.PLESE_ENTER_THE_CORRECT_OTP = 'Please enter the correct OTP.';
exports.RouteTypes = {
    SET_HEIGHT: 'SET_HEIGHT',
    SET_CURRENT_HEIGHT: 'SET_CURRENT_HEIGHT',
    CloseLoading: 'CloseLoading',
    ShowLoading: 'ShowLoading',
    ScrollToTop: 'ScrollToTop',
    RefreshSession: 'RefreshSession',
    TOKEN_EXPIRED: 'tokenExpired',
    REVOKE_USER: 'revokeUser',
    FORCE_EXIT_USER: 'forceExitUser',
};
exports.SYSTEM_MESSAGES_TRANSACTION_SIGNING = {
    OTP_ERROR_EMPTY_OTP: {
        type: 'ERROR',
        msgId: 'transaction-signing-otp-error-empty-otp',
        defaultMsg: PLESE_ENTER_YOUR_OTP
    },
    OTP_ERROR_INCORRECT_OTP: {
        type: 'ERROR',
        msgId: 'transaction-signing-otp-error-incorrect-otp',
        defaultMsg: PLESE_ENTER_YOUR_OTP
    }
};
exports.SYSTEM_MESSAGES_LOGIN2FA = {
    OTP_ERROR_EMPTY_OTP: {
        type: 'ERROR',
        msgId: 'login-2fa-otp-error-empty-otp',
        defaultMsg: PLESE_ENTER_YOUR_OTP
    },
    OTP_ERROR_INCORRECT_OTP: {
        type: 'ERROR',
        msgId: 'login-2fa-otp-error-incorrect-otp',
        defaultMsg: PLESE_ENTER_YOUR_OTP
    }
};
exports.VerifyDataStatusFirstCall = {
    TAC: 'TAC_REQUIRED',
    TWOFAUNLOCK: '2FAUNLOCKTTTTTTTTT',
    PINMAILER: 'PIN-MAILER-REQUEST'
};
exports.SYSTEM_MESSAGE_HARD_TOKEN = {
    INVALID_RESPONSE_CODE: {
        type: 'ERROR',
        msgId: 'transaction-signing-hard-token-invalid-code',
        defaultMsg: 'Please enter the correct {digit}-digit code.'
    },
    HOST_ERROR: {
        type: 'ERROR',
        msgId: 'transaction-signing-hard-token-incorrect-code',
        defaultMsg: 'We are encountering an unexpected error. Please try again later.'
    },
    EXCEED_2FA_MAX_ATTEMPT: {
        type: 'ERROR',
        msgId: 'transaction-signing-hard-token-max-failed-attempt',
        defaultMsg: 'Maximum failed response code attempt.'
    },
    USER_NO_ACTIVE_HARD_TOKEN: {
        type: 'ERROR',
        msgId: 'transaction-signing-hard-token-not-activated',
        defaultMsg: 'Your Secure Token is not activated. Please proceed to activate your Secure Token.'
    },
    USER_NO_ACTIVE_SOFT_TOKEN: {
        type: 'ERROR',
        msgId: 'transaction-signing-hard-token-not-activated',
        defaultMsg: 'Your Secure Token is not activated. Please proceed to activate your Secure Token.'
    }
};
exports.OFFLINE_OTP = {
    INVALID_RESPONSE_CODE: {
        type: 'ERROR',
        msgId: 'transaction-signing-offline-invalid-code',
        defaultMsg: exports.PLESE_ENTER_THE_CORRECT_OTP
    }
};
exports.R4_MESSAGE_TYPE = {
    IFRAME_READY: 'IFRAME_READY',
    INIT_TAC: 'INIT_TAC',
    UPDATE_TOKEN: 'UPDATE_TOKEN',
    TAC_SUCCESS: 'TAC_SUCCESS',
    TAC_CANCEL: 'TAC_CANCEL'
};
exports.isR4 = window.location.pathname.includes('/auth-request');
exports.parentOrigin = document.referrer ? new URL(document.referrer).origin : "*";
